
import React from 'react';
import { Button } from '@/components/ui/button';

const PricingSection: React.FC = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Simple, Transparent Pricing</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We offer predictable monthly rates based on your business needs. No surprise bills or hidden fees.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col">
            <div className="p-6 bg-itmgmt-dark-blue text-white text-center">
              <h3 className="text-xl font-bold mb-2">Basic Support</h3>
              <div className="flex justify-center items-baseline my-4">
                <span className="text-4xl font-bold">$40</span>
                <span className="text-lg ml-1">/user/mo</span>
              </div>
            </div>
            <div className="p-6 flex flex-col flex-grow">
              <ul className="space-y-3 mb-6 flex-grow">
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>NinjaOne Remote Monitoring</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>SentinelOne EDR Protection</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Automated Patch Management</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Security & Performance Reporting</span>
                </li>
              </ul>
              <div className="mt-auto">
                <Button asChild className="button-primary w-full">
                  <a href="#contact">Get Started</a>
                </Button>
              </div>
            </div>
          </div>
          
          <div className="border rounded-lg overflow-hidden shadow-md relative transform scale-105 z-10 flex flex-col">
            <div className="absolute top-0 right-0 bg-itmgmt-bright-blue text-white py-1 px-3 text-sm">
              Popular
            </div>
            <div className="p-6 bg-itmgmt-medium-blue text-white text-center">
              <h3 className="text-xl font-bold mb-2">Full Help Desk</h3>
              <div className="flex justify-center items-baseline my-4">
                <span className="text-4xl font-bold">$100</span>
                <span className="text-lg ml-1">/user/mo</span>
              </div>
            </div>
            <div className="p-6 flex flex-col flex-grow">
              <ul className="space-y-3 mb-6 flex-grow">
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Everything in Basic Support</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Unlimited Remote Support</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Priority Response Time</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Monthly IT Strategy Review</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Cloud Email & Productivity Suite Management</span>
                </li>
              </ul>
              <div className="mt-auto">
                <Button asChild className="button-primary w-full">
                  <a href="#contact">Get Started</a>
                </Button>
              </div>
            </div>
          </div>
          
          <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col">
            <div className="p-6 bg-itmgmt-dark-blue text-white text-center">
              <h3 className="text-xl font-bold mb-2">Custom Solutions</h3>
              <div className="flex justify-center items-baseline my-4">
                <span className="text-lg">Custom Pricing</span>
              </div>
            </div>
            <div className="p-6 flex flex-col flex-grow">
              <ul className="space-y-3 mb-6 flex-grow">
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Everything in Full Help Desk</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>On-Site Support</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Hardware as a Service (HaaS)</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Premium SLA Guarantees</span>
                </li>
                <li className="flex items-center">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Executive IT Planning</span>
                </li>
              </ul>
              <div className="mt-auto">
                <Button asChild className="button-primary w-full">
                  <a href="#contact">Contact Us</a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
